import Refer from ".";
import authRoles from "../../utils/auth.roles";
const ReferRoutes = {
  name: 'ReferRoutes',
  auth: authRoles.user,
  kyc: false,
  mfaNotRequired: true,
  routes: [
    {
      path: "/refer",
      component: Refer,
      exact: true,
    },
  ],
};
export default ReferRoutes;
